import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry"

// import PagingControler from "../../Common/Controllers/PagingController";
import PresentationController from "../../../../../../../src-js/Fratello/ProductBrowser/Controllers/PresentationController";

export default function Header({
    sorting,
    sort,
    perPageOptions,
    paging,
    presentation,
    productView,
    onSort,
    onChangePage,
    onChangeView,
    onChangeItemsPerPage,
    labels,
    state,
    filters
}) {
    const Choice = ComponentRegistry.get("Choice");

    return (
      <header className="row-paging clearfix">
        
      </header>
    );
}

Header.propTypes = {
    sorting: PropTypes.shape({}),
    sort: PropTypes.string,
    paging: PropTypes.shape({}),
    perPageOptions: PropTypes.shape({}),
    presentation: PropTypes.shape({}),
    productView: PropTypes.string,
    onSort: PropTypes.func.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeView: PropTypes.func.isRequired,
    onChangeItemsPerPage: PropTypes.func.isRequired,
    labels: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Atoms/Header.jsx